import { render, staticRenderFns } from "./EventBaseCard.vue?vue&type=template&id=adae857c&scoped=true"
var script = {}
import style0 from "./EventBaseCard.vue?vue&type=style&index=0&id=adae857c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adae857c",
  null
  
)

export default component.exports